//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import GoHome from '@/components/subComponents/GoHome'
import MyFooter from '@/components/subComponents/MyFooter'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "FreightPrice",
    components: {
        MyFooter,
        MyBtnReturn,
        GoHome,
    },
    data() {
        return {
            place_loading: null,
            place_loadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            place_delivery: null,
            place_deliveryOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ], // 目的港要根据起始港调用接口查询
            group: '', // 后台返回的
            shipper: '', // 后台返回的
            areaUrl: '', // 查询地点API，freightPrice，该接口还会拿到shipper与group，后续调用表格数据接口时也要传给后台
            // tableDataUrl: '', // 查询表单数据API，freightPriceTemplate
        }
    },
    created() {
        document.title = '全程运输报价查询';
        this.areaUrl = apiUrl.freightPrice;
        this.searchArea()
    },
    methods: {
        searchArea() {
            // 获取起始与目的等地点:如果没获取到，要提示用户重新打开页面吗？
            // 该接口还会拿到shipper与group，后续调用表格数据接口时也要传给后台
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            this.requestApi({
                url: this.areaUrl,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                // 囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                this.place_loadingOps = dataObj.starts || []; // 防止后台返回null
                this.place_deliveryOps = dataObj.ends || []; // 防止后台返回null
                this.group = dataObj.group || ''; // 防止后台返回null
                this.shipper = dataObj.shipper || ''; // 防止后台返回null
            }, (error) => {
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        goResultPage() {
            let route = {
                name: 'FreightPriceResult',
                query: {
                    place_loading: this.place_loading || '',
                    place_delivery: this.place_delivery || '',
                    group: this.group,
                    shipper: this.shipper,
                    openId: apiParams.openId,
                    companyId: apiParams.companyId,
                    code: apiParams.code,
                }
            };
            this.$router.push(route)
        },
        startChange(value) {
            if (!value) return;
            // 去获取目的地的数据：这是根据起运地获取的，数量应该没startAreaUrl接口的多吧？
            // 加一个loading，顺便可以不让用户又去选择另一个起运地
            this.$vux.loading.show({
                text: 'Loading'
            });
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                start: this.place_loading || '',
            };
            this.requestApi({
                url: apiUrl.changePlace,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                let dataObj = resultData.data;
                this.place_deliveryOps = dataObj.findEndPlace || []; // 防止后台返回null
                this.place_delivery = null; // 目的地被选中项变为null，不然查询时会记忆回来选择的
            }, (error) => {
                this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            })
        },
        targetChange(value) {
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/kehu/freightPrice/FreightPrice.vue